import baseAPI from '../../axiosApi'

const api={
    list:'/api-ir/course/program/page',
    add:'/api-ir/course/program/add',
    update:'/api-ir/course/program/edit',
    info:'/api-ir/course/program/info/',
    del:'/api-ir/course/program/delete/',
    approve:'/api-ir/course/program/approve'
}
// 查询课程大纲列表
export function list (data) {
    return baseAPI.axiosData(api.list,'get',data)
}
// 新增课程大纲
export function add (data) {
    return baseAPI.axiosData(api.add,'post',data)
}
// 修改课程大纲
export function update (data) {
    return baseAPI.axiosData(api.update,'put',data)
}
// 查询课程大纲信息
export function info (id) {
    return baseAPI.axiosData(api.info+id,'get')
}
// 删除课程大纲
export function del (id) {
    return baseAPI.axiosData(api.del+id,'delete')
}
// 审批课程大纲
export function approve (data) {
    return baseAPI.axiosData(api.approve,'get',data)
}
